import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaChevronDown } from 'react-icons/fa';
import './FAQ.css';

const FAQ = ({ faqCategories = {} }) => {
  const [openCategoryIndex, setOpenCategoryIndex] = useState(-1);
  const [openQuestionIndex, setOpenQuestionIndex] = useState({}); // store per category

  const toggleCategory = (idx) => {
    setOpenCategoryIndex(openCategoryIndex === idx ? -1 : idx);
    setOpenQuestionIndex({}); // reset questions when switching category
  };

  const toggleQuestion = (catIdx, qIdx) => {
    setOpenQuestionIndex((prev) => ({
      ...prev,
      [catIdx]: prev[catIdx] === qIdx ? -1 : qIdx
    }));
  };

  return (
    <section className="faq-section container">
      <h1 className="faq-heading">Frequently Asked Questions</h1>

      {Object.keys(faqCategories).map((category, catIdx) => (
        <div key={category} className="faq-category">
          {/* CATEGORY HEADER */}
          <button
            className="faq-category-btn"
            onClick={() => toggleCategory(catIdx)}
          >
            {category}
            <span className={`faq-chevron${openCategoryIndex === catIdx ? ' open' : ''}`}>
              <FaChevronDown />
            </span>
          </button>

          {/* CATEGORY CONTENT */}
          <AnimatePresence>
            {openCategoryIndex === catIdx && (
              <motion.div
                className="faq-category-content"
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: 'auto' }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.3 }}
              >
                {faqCategories[category].map((faq, qIdx) => (
                  <div
                    key={qIdx}
                    className={`faq-item${openQuestionIndex[catIdx] === qIdx ? ' open' : ''}`}
                  >
                    {/* QUESTION HEADER */}
                    <button
                      className="faq-question"
                      onClick={() => toggleQuestion(catIdx, qIdx)}
                    >
                      {faq.question}
                      <span
                        className={`faq-chevron${openQuestionIndex[catIdx] === qIdx ? ' open' : ''}`}
                      >
                        <FaChevronDown />
                      </span>
                    </button>

                    {/* ANSWER */}
                    <AnimatePresence initial={false}>
                      {openQuestionIndex[catIdx] === qIdx && (
                        <motion.div
                          className="faq-answer"
                          initial={{ opacity: 0, height: 0 }}
                          animate={{ opacity: 1, height: 'auto' }}
                          exit={{ opacity: 0, height: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          {faq.answer}
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </div>
                ))}
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ))}

      <div className="faq-help">
        Still need help? <a href="/contact" className="faq-help-link">Get Help Now</a>
      </div>
    </section>
  );
};

export default FAQ;
